import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import { useRegistrationStore } from '../../store/store.ts';
import { OPTED_OUT_WELCOME_OFFER_ID, TEST_ID } from '../../utils/constants.ts';
import { GtmEvents } from '../../utils/gtm/gtm.ts';

type TNoBonusButton = {
  label?: string;
  handleNext: ({ gtmPayload, redirectTo }: { gtmPayload?: Record<string, string>; redirectTo?: string }) => void;
}

const NoBonusButton = ({ label, handleNext }: TNoBonusButton) => {

  const { setFormData, setMetadata, metadata } = useRegistrationStore();

  const handleClick = () => {
    setFormData({ welcomeOffer: OPTED_OUT_WELCOME_OFFER_ID });
    setMetadata({ selectedWoDescription: '', selectedWoName: '' });
    GtmEvents.handleWelcomeOfferEvent(null, metadata?.currentStep);
    handleNext?.({ redirectTo: '1' });
  };

  return (
    <Button
      variant="tertiary"
      className="focus:outline-none focus:ring-purpleblue focus:ring-offset-0 focus:ring-2 text-white"
      onClick={handleClick}
      data-testid={TEST_ID.BUTTON_SECONDARY}
    >
      {label}
    </Button>
  );
};

const Memoized = memo(NoBonusButton);
Memoized.displayName = 'NoBonusButton';

export default Memoized;
